export default __webpack_public_path__ + "static/media/02.9793f1d4.png";